exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-menu-item {\n  position: relative;\n  width: 430px;\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n}\n:host /deep/ circle.active {\n  r: 8;\n  fill: #27B2CF;\n  stroke: white;\n}\n:host /deep/ circle.displayed {\n  r: 8;\n}\n:host /deep/ circle.hover:not(.active),\n:host /deep/ circle.displayed:not(.active) {\n  fill: #bd0fe2;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/overlays/components/timeline/timeline.component.less
// module id = ../../../../../src/app/packages/overlays/components/timeline/timeline.component.less
// module chunks = main